import { render, staticRenderFns } from "./combinationRepeat.vue?vue&type=template&id=71ca6e32&scoped=true&"
import script from "./combinationRepeat.vue?vue&type=script&lang=js&"
export * from "./combinationRepeat.vue?vue&type=script&lang=js&"
import style0 from "./combinationRepeat.vue?vue&type=style&index=0&id=71ca6e32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca6e32",
  null
  
)

export default component.exports